import React, { useState } from "react";
import { toast } from "react-toastify";
import { adminMainUrl } from "../../../../Config";
import Cookies from "js-cookie";

const LedgerAccountBankDetails = ({
  ledger_account_id,
  ledgerFormData,
  onValueChange,
  bank_details,
  onBankChange,
  onAddNew,
  onRemove,
  saveAndNext,
  tabId,
  backId,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmAcc, setConfirmAcc] = useState("");
  const [confirmations, setConfirmations] = useState({}); // { 0: "1234...", 1: "5678...", ... }

  // Basic validation for bank details
  const validateBankDetails = () => {
    if (!bank_details || bank_details.length === 0) {
      toast.error("Please add at least one bank account");
      return false;
    }

    for (let i = 0; i < bank_details.length; i++) {
      const bank = bank_details[i];

      // 1. Account number & confirmation match
      if (
        (bank.account_number || "").trim() !==
        (bank.confirm_account_number || "").trim()
      ) {
        toast.error(`Account numbers do not match in bank entry form ${i + 1}`);
        return false;
      }

      // 2. Account number is filled
      if (!bank.account_number?.trim()) {
        toast.error(`Account Number is required for bank entry form ${i + 1}`);
        return false;
      }

      // 3. IFSC required
      if (!bank.ifsc_code?.trim()) {
        toast.error(`IFSC Code is required for bank entry form ${i + 1}`);
        return false;
      }

      // 4. Basic IFSC format (Indian standard)
     

      // 5. Bank Name (you're using branch_name in form, but label says Bank Name)
      if (!bank.branch_name?.trim()) {
        toast.error(`Bank Name is required for bank entry form ${i + 1}`);
        return false;
      }

      // 6. Optional: make branch address required
      if (!bank.branch_address?.trim()) {
        toast.error(`Branch Address is required for bank entry form ${i + 1}`);
        return false;
      }
    }

    return true;
  };

  const submitLedgerForm = async () => {
    // Validate before sending to server
    if (!validateBankDetails()) {
      return;
    }

    setIsSubmitting(true);

    // console.log("bank_details", bank_details);

    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/ledger-account`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify({
            ledger_account_id,
            bank: bank_details,
          }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Bank details saved successfully");
        saveAndNext(tabId);
      } else {
        toast.error(data?.msg || "Failed to save bank details");
        console.error("Error saving bank details:", data.message);
      }
    } catch (error) {
      toast.error("Network error while saving bank details");
      console.error("Network error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const addNewBankSection = () => {
    if (!validateBankDetails()) {
      return;
    }
    onAddNew();
  };

  return (
    <>
      {bank_details.map((item, index) => (
        <div
          key={index}
          className="row bg-white p-3 mb-4 position-relative shadow-sm rounded"
        >
          <div className="d-flex justify-content-end  mb-3">
            {index > 0 && (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="btn btn-primary "
                title="Remove this address"
              >
                <i className="fas fa-trash"></i>
              </button>
            )}
          </div>
          {/* account_number (confirmation field - optional) */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Confirm Account Number
            </label>
            <input
              type="text"
              className="form-control bg-light"
              placeholder="Re-enter account number"
              value={item.confirm_account_number || ""}
              onChange={(e) => {
                // Optional: you can add confirmation logic here
                onBankChange(index, {
                  target: {
                    name: "confirm_account_number",
                    value: e.target.value,
                  },
                });
              }}
              // onChange={(e) => setConfirmAcc(e.target.value)}
            />
          </div>

          {/* account_number */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Account Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="account_number"
              className="form-control bg-light"
              placeholder="Enter account number"
              onChange={(e) => onBankChange(index, e)}
              value={item.account_number || ""}
            />
          </div>

          {/* ifsc_code */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              IFSC Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="ifsc_code"
              className="form-control bg-light"
              placeholder="Enter IFSC code (e.g. SBIN0001234)"
              onChange={(e) => onBankChange(index, e)}
              value={item.ifsc_code || ""}
              maxLength={11}
            />
          </div>

          {/* Bank Name */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Bank Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="branch_name" // Note: field name is branch_name but label says Bank Name
              className="form-control bg-light"
              placeholder="Enter Bank name"
              onChange={(e) => onBankChange(index, e)}
              value={item.branch_name || ""}
            />
          </div>

          {/* branch_address */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">Branch Address</label>
            <input
              type="text"
              name="branch_address"
              className="form-control bg-light"
              placeholder="Enter branch address"
              onChange={(e) => onBankChange(index, e)}
              value={item.branch_address || ""}
            />
          </div>

          {/* Remove button (except first) */}
          {/* {index > 0 && (
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="btn btn-primary "
              title="Remove this bank detail"
            >
              <i className="fas fa-trash"></i>
            </button>
          )} */}
        </div>
      ))}

      {/* Bottom Action Buttons */}
      {/* <div className="d-flex gap-2 mt-4 flex-wrap">
        <button
          onClick={() => saveAndNext(backId)}
          className="btn btn-primary border px-4"
          disabled={isSubmitting}
        >
          Back
        </button>

        <button
          onClick={submitLedgerForm}
          className="btn btn-primary px-4"
          disabled={isSubmitting}
        >
          <i className="fas fa-save me-1"></i>
          {isSubmitting ? "Saving..." : "Save & Next"}
        </button>

        <button
          className="btn btn-light border px-4"
          onClick={() => addNewBankSection()}
          disabled={isSubmitting}
        >
          <i className="fas fa-plus me-1"></i> Add Bank Account
        </button>
      </div> */}

      <div className="d-flex flex-wrap gap-3 justify-content-between mt-2">
        <div className="d-flex gap-3">
          <button
            type="button"
            className="btn btn-primary px-5"
            onClick={() => saveAndNext(backId)}
          >
            Back
          </button>

          <button
            type="button"
            className="btn btn-primary px-5"
            onClick={submitLedgerForm}
          >
            Save & Next
          </button>
        </div>

        <button
          type="button"
          className="btn btn-light px-4"
          onClick={addNewBankSection}
        >
          <i className="fas fa-plus me-2"></i>Add Bank Account
        </button>
      </div>
    </>
  );
};

export default LedgerAccountBankDetails;
